<template>
  <div style="background: #1f1c1f;">
    <div class="header">
      <div class="header_content">
        <!-- 左：Logo -->
        <div class="brand_left">
          <img class="brand_logo" src="/img/clogo.jpg" alt="" />
        </div>

        <!-- 中：标题居中 -->
        <div class="brand_center">浪漫情緣</div>

        <!-- 右：注册按钮（逻辑不变） -->
        <div class="brand_right">
          <div v-if="!hasToken" class="btn_register" @click="toLogin('/Register')">
            {{ $t("auth.register") }}
          </div>
          <div v-else></div>
        </div>
      </div>
    </div>

    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="banner_img" :src="`${v.url}`" width="100%" height="160px">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <div style="padding: 10px;">
      <van-notice-bar
        class="notice-swiper"
        color="#f3c7a2"
        background="#313131"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="/img/neww/notice.png"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>

    <div class="nav_box">
      <div class="x_p" @click="toLogin('/Lottery')">
        <img src="/img/neww/ico_vote.png" alt="" />
        <div class="text_c">{{ $t("q37") }}</div>
      </div>
      <div class="x_p" @click="toLogin('/ServiceOnline')">
        <img src="/img/neww/ico_new.png" alt="" />
        <div class="text_c">{{ $t("q38") }}</div>
      </div>
      <div class="x_p" @click="toLogin('/Video')">
        <img src="/img/neww/ico_video.png" alt="" />
        <div class="text_c">{{ $t("q39") }}</div>
      </div>
      <div class="x_p" @click="toLogin('/Choose')">
        <img src="/img/neww/ico_vip.png" alt="" />
        <div class="text_c">{{ $t("q40") }}</div>
      </div>
    </div>

    <!-- 热门城市 -->
    <div class="wuzii" @click="toLogin('/Choose')">
      <div class="put_tit">{{ $t("q41") }}：</div>

      <div class="xx_bc">
        <div class="top_link" v-for="k in hotCityKeys" :key="k">
          {{ cityLabel(k) }}
        </div>
      </div>

      <!-- +更多区域（路由=约会） -->
      <div class="more_area_wrap">
        <div class="more_area_btn" @click.stop="toLogin('/Choose')">+ 更多區域</div>
      </div>
    </div>

    <div class="wuzii_p">
      <div class="put_tit">{{ $t("q52") }}</div>
      <div class="xx_bc_u" @click="toLogin('/Choose')">
        {{ $t("q53") }}
      </div>
    </div>

    <div class="tu_list">
      <div class="tu_item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
        <div class="renzh">{{ $t("q54") }}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <div class="c_c">{{ $t("index.height") }}: {{ item.hight }}cm</div>
          <div class="c_c">{{ $t("index.bust") }}：{{ item.bust }}</div>
          <div class="c_c">
            {{ $t("index.address") }}： {{ $t("index.National") }}：{{ $t("index.yes") }}
          </div>
          <div class="c_b_k">
            <img src="/img/neww/icon_views.png" class="sm_in" />
            <span>{{ item.chakan }}</span>
            <img src="/img/neww/icon_love.png" class="sm_in cc" />
            <span>{{ item.dianzan }}</span>
          </div>
        </div>
        <img :src="item.img_url" class="sm_in_c van-image__img" style="object-fit: cover;" />
      </div>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],

      // ✅ 热门城市：原 10 个 q42~q51 + 新增 2 个（不影响原翻译）
      // 你如果后续要做成可翻译：把 “宜蘭/屏東” 改成新 key 并补语言包即可
      hotCityKeys: ["q42","q43","q44","q45","q46","q47","q48","q49","q50","q51","宜蘭","屏東"],

      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ["primary", "success", "danger", "warning"]
    };
  },
  methods: {
    // ✅ 城市显示：qxx 走语言包，其它直接显示文字（不影响现有逻辑）
    cityLabel(k) {
      const isKey = typeof k === "string" && /^q\d+$/.test(k);
      return isKey ? this.$t(k) : k;
    },

    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config"
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },

    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot"
      }).then((res) => {
        console.log(res, 11);
      });
    },

    getBanner(data) {
      this.banners = data.banners;
    },

    toLogin(str) {
      this.$router.push({ path: str });
    },

    getNotice(data) {
      this.notice = data.notice;
    },

    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;
        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },

    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },

    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },

    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 }
      }).then((res) => {
        const lang = localStorage.getItem("lang"); // 只保留 zh/en，其他都按 zh
        this.datalist = res.data || [];

        this.datalist.forEach((item) => {
          const parts = String(item.flag || "").split("|");

          // 只支持 zh/en：en 用 parts[1]，其他默认 parts[0]
          const idx = lang === "en" ? 1 : 0;

          const selected = (parts[idx] ?? parts[0] ?? "").trim();
          item.flag = selected;

          // 兼容中文逗号/英文逗号
          item.flagArray = selected ? selected.split(/[,，]/).filter(Boolean) : [];
        });

        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    }
  },

  mounted() {
    // 你模板里滚动那块如果注释掉了，这里不再报错
    if (this.$refs.scrollContainer && this.$refs.scrollContainer.clientHeight) {
      this.containerHeight = this.$refs.scrollContainer.clientHeight;
      this.startAnimation();
    }
  },

  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery();
  }
};
</script>

<style lang="less" scoped>
/* ===== Header 调整：Logo 左、标题居中、按钮右 ===== */
.header {
  height: 13vw;
}
.header_content {
  height: 100%;
  margin: 0 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}
.brand_left {
  display: flex;
  align-items: center;
  min-width: 120px;
}
.brand_logo {
  width: 60px;
  height: 60px;
  border-radius: 14px; /* ✅ Logo 圆角调整 */
  object-fit: cover;
  display: block;
}
.brand_center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #e6b98a;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: 2px;
  white-space: nowrap;
}
.brand_right {
  min-width: 120px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.btn_register {
  color: #f3c7a2;
  font-size: 28px;
}

/* ===== 原样保留 ===== */
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}

.nav_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  .x_p {
    text-align: center;
    color: #e6b98a;
    flex: 1;
    img {
      height: 76px;
    }
  }
}

.put_tit {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}

/* ===== 热门城市：更像你截图的排版（4列网格 + 按钮） ===== */
.wuzii {
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;

  .xx_bc {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px 10px;
    font-size: 26px;
    color: #ccc;

    .top_link {
      text-align: center;
      padding: 10px 0;
      border-radius: 10px;
    }
  }

  .more_area_wrap {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
  .more_area_btn {
    padding: 12px 20px;
    border-radius: 10px;
    background: #e6b98a;
    color: #2b1f16;
    font-size: 26px;
    font-weight: 700;
    border: 1px solid rgba(0, 0, 0, 0.2);
    user-select: none;
  }
}

.wuzii_p {
  margin: 26px 20px 16px;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u {
    color: #ccc;
  }
}

.tu_list {
  .tu_item {
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh {
      position: absolute;
      right: -72px;
      top: 32px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c {
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box {
      .c_id {
        width: 200px;
        text-align: center;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c {
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in {
          width: 30px;
          height: 30px;
          &.cc {
            margin-left: 16px;
          }
        }
      }
    }
  }
}

/* 以下原样保留 */
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}
.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
</style>
